import { isFeatureDisabled } from 'src/utils/featureFlag';
import { FEATURES_NAMES } from 'src/utils/featureFlag/types';

export const addEvent = (event) => {
  if (isFeatureDisabled(FEATURES_NAMES.FF_SCRIPT_GOOGLE_TAG_MANAGER)) return;

  window.dataLayer?.push(event);
};
